<template>
  <div class="w-[96%] mx-auto" style="margin-top: 16px">
    <!-- <div class="flex gap-4 mb-4">
      <el-card class="flex-1 cursor-pointer" @click="activeCard = 'submitForm'">
        提交资料
      </el-card>
      <el-card
        class="flex-1 cursor-pointer"
        @click="activeCard = 'submitRecord'"
      >
        <template #header>
          <div class="card-header">
            <span>提交记录</span>
          </div>
        </template>
      </el-card>
    </div> -->

    <wd-segmented :options="list" v-model:value="current" :vibrate-short="true">
      <template #label="{ option }">
        <view class="section-slot">
          <image
            style="border-radius: 50%; width: 32px; height: 32px"
            :src="option.payload.avatar"
          />
          <view class="name">{{ option.value }}</view>
        </view>
      </template>
    </wd-segmented>

    <el-button
      color="#626aef"
      :dark="isDark"
      :icon="Search"
      @click="activeCard = 'submitForm'"
      >提交资料</el-button
    >
    <el-button
      color="#626aef"
      :icon="Eleme"
      @click="activeCard = 'submitRecord'"
      >提交记录</el-button
    >
    <!-- <div class="flex gap-2">
      <el-check-tag
        :checked="checked1"
        @change="onChange1"
        @click="activeCard = 'submitForm'"
        >提交资料</el-check-tag
      >
      <el-check-tag
        type="success"
        :checked="checked2"
        @change="onChange2"
        @click="activeCard = 'submitRecord'"
        >提交记录</el-check-tag
      >
    </div> -->

    <el-card v-if="activeCard === 'submitForm'" style="margin-top: 16px">
      <template #header>
        <div class="card-header">
          <span>患者基本信息</span>
        </div>
      </template>
      <el-form
        :model="patientForm"
        :rules="rules"
        ref="patientFormRef"
        label-width="80px"
      >
        <el-form-item label="患者姓名">
          <el-input v-model="patientForm.patientname"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="patientForm.patientphone"></el-input>
        </el-form-item>
        <el-form-item label="诊断信息">
          <el-select
            v-model="patientForm.diagnosis"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
            placeholder="请选择诊断信息"
          >
            <el-option-group
              v-for="group in diagnosisOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="检查报告" prop="medicalPhoto">
          <el-upload
            name="files"
            :limit="12"
            :data="{ userId: userId }"
            list-type="picture"
            multiple
            :on-success="handleFileSuccess"
            :http-request="uploadToLafnew"
          >
            <div class="flex items-center">
              <el-button slot="trigger" size="small" type="primary"
                >选择文件</el-button
              >
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 16px" v-if="activeCard === 'submitForm'">
      <template #header>
        <div class="card-header">
          <span>意向医院信息</span>
        </div>
      </template>
      <el-form
        :model="referralForm"
        :rules="rules"
        ref="referralFormRef"
        label-width="80px"
      >
        <el-form-item label="意向医院">
          <el-select
            v-model="referralForm.referralhospital"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
            placeholder="请选择医院"
          >
            <el-option-group
              v-for="group in hospitalOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="意向科室">
          <el-select
            v-model="referralForm.referraldepartment"
            placeholder="请选择科室"
          >
            <el-option
              v-for="item in departmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="意向医生">
          <el-input v-model="referralForm.referraldoctorName"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="flex justify-end mt-4">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </template>
    </el-card>
    <el-card v-if="activeCard === 'submitRecord'" style="margin-top: 16px">
      <template #header>
        <div class="card-header">
          <span>提交记录</span>
        </div>
      </template>
      <el-table :data="submitRecords" style="width: 100%">
        <el-table-column prop="patientname" label="患者姓名" />
        <el-table-column prop="patientphone" label="联系电话" />
        <el-table-column prop="diagnosis" label="诊断信息" />
        <el-table-column prop="referralhospital" label="意向医院" />
        <el-table-column prop="referraldepartment" label="意向科室" />
        <el-table-column prop="referraldoctorName" label="意向医生" />
      </el-table>
    </el-card>
  </div>
</template>

<!-- <template>
  <div class="w-[96%] mx-auto" style="margin-top: 16px">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>患者基本信息</span>
        </div>
      </template>
      <el-form :model="patientForm" label-width="80px">
        <el-form-item label="患者姓名">
          <el-input v-model="patientForm.patientname"></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input v-model="patientForm.patientphone"></el-input>
        </el-form-item>
        <el-form-item label="诊断信息">
          <el-select
            v-model="patientForm.diagnosis"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
            placeholder="请选择诊断信息"
          >
            <el-option-group
              v-for="group in diagnosisOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="检查报告" prop="medicalPhoto">
          <el-upload
            name="files"
            :limit="12"
            :data="{ userId: userId }"
            list-type="picture"
            multiple
            :on-success="handleFileSuccess"
            :http-request="uploadToLafnew"
          >
            <div class="flex items-center">
              <el-button slot="trigger" size="small" type="primary"
                >选择文件</el-button
              >
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 16px">
      <template #header>
        <div class="card-header">
          <span>意向医院信息</span>
        </div>
      </template>
      <el-form :model="referralForm" label-width="80px">
        <el-form-item label="意向医院">
          <el-select
            v-model="referralForm.referralhospital"
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
            placeholder="请选择医院"
          >
            <el-option-group
              v-for="group in hospitalOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="意向科室">
          <el-select
            v-model="referralForm.referraldepartment"
            placeholder="请选择科室"
          >
            <el-option
              v-for="item in departmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="意向医生">
          <el-input v-model="referralForm.referraldoctorName"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="flex justify-end mt-4">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </template>
    </el-card>
  </div>
</template> -->

<script setup>
import { Search, Eleme } from "@element-plus/icons-vue";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import {
  PatientReferalPatient,
  PatientUploadFiles,
} from "../../api/ReferalPatient";
import { FILE_BASE_URL } from "../../api/baseUrl";

import { getsealospatientdata } from "../../api/GetSeaos";
import { nanoid } from "nanoid";
import { departmentOptions } from "./departments";
import { diagnosisOptions } from "./diagnosis";
import { hospitalOptions } from "./hospitals";

const route = useRoute();
const router = useRouter();

const activeCard = ref("submitForm"); // 默认显示提交资料表单


const list = ref([
  {
    value: '李雷',
    disabled: false,
    payload: {
      avatar: 'https://registry.npmmirror.com/wot-design-uni-assets/*/files/redpanda.jpg'
    }
  },
  {
    value: '韩梅梅',
    disabled: false,
    payload: {
      avatar: 'https://registry.npmmirror.com/wot-design-uni-assets/*/files/capybara.jpg'
    }
  }
])

const patientForm = ref({
  patientid: "",
  patientname: "",
  patientphone: "",
  diagnosis: [],
  medicalPhoto: [],
});
const rules = {
  patientname: [{ required: true, message: "请输入患者姓名", trigger: "blur" }],
  patientphone: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入有效的手机号码",
      trigger: "blur",
    },
  ],
  diagnosis: [{ required: true, message: "请选择诊断信息", trigger: "change" }],
  referralhospital: [
    { required: true, message: "请选择意向医院", trigger: "change" },
  ],
  referraldepartment: [
    { required: true, message: "请选择意向科室", trigger: "change" },
  ],
  referraldoctorName: [
    { required: true, message: "请输入意向医生", trigger: "blur" },
  ],
};
const referralForm = ref({
  referralhospital: "复旦大学附属肿瘤医院",
  referraldepartment: "",
  referraldoctorName: "",
});

const submitRecords = ref([]); // 提交记录数据

const validateForm = () => {
  return new Promise((resolve, reject) => {
    const patientFormValid = Object.keys(rules).every((key) => {
      if (key in patientForm.value) {
        const rule = rules[key];
        const value = patientForm.value[key];
        if (rule.required && !value) {
          reject(new Error(rule.message));
          return false;
        }
        if (rule.pattern && !rule.pattern.test(value)) {
          reject(new Error(rule.message));
          return false;
        }
      }
      return true;
    });

    const referralFormValid = Object.keys(rules).every((key) => {
      if (key in referralForm.value) {
        const rule = rules[key];
        const value = referralForm.value[key];
        if (rule.required && !value) {
          reject(new Error(rule.message));
          return false;
        }
        if (rule.pattern && !rule.pattern.test(value)) {
          reject(new Error(rule.message));
          return false;
        }
      }
      return true;
    });

    if (patientFormValid && referralFormValid) {
      resolve();
    }
  });
};

const getrecords = async (id) => {
  const res = await getsealospatientdata(id);
  console.log("records", res);

  submitRecords.value = res.data;
};

onMounted(() => {
  // 从 Local Storage 获取唯一标识符
  const uniqueId = localStorage.getItem("uniqueId");
  if (uniqueId) {
    console.log("旧uniqueId", uniqueId);
    patientForm.value.patientid = uniqueId;

    getrecords(uniqueId);
    //fetchData(uniqueId); // 使用该标识符获取数据
  } else {
    const uniqueId = generateUUID();

    console.log("新建uniqueId", uniqueId);
    patientForm.value.patientid = uniqueId;

    getrecords(uniqueId);
    // 保存唯一标识符到 Local Storage
    localStorage.setItem("uniqueId", uniqueId);
  }

  // 从 Local Storage 获取唯一标识符
  // const uniqueId = localStorage.getItem('uniqueId');
  // if (uniqueId) {
  //   fetchData(uniqueId); // 使用该标识符获取数据
  // }
  //   try {
  //     Object.assign(userinfo.value, route.query);
  //     console.log("转诊资料填写页", userinfo.value);
  //   } catch (error) {
  //     console.error("获取信息时出错:", error);
  //   }
});

// 使用 JavaScript 生成 UUID
const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const goToRouter = (name, query) => {
  router.replace({ name, query }); // 传递用户信息
  //router.push({ name: "DoctorHome", query: userInfo }); // 传递用户信息
};

const handleFileSuccess = (response, file, fileList) => {
  console.log("文件上传响应:", response);

  if (!response) return;

  const { files } = response;

  if (!Array.isArray(patientForm.value.medicalPhoto)) {
    patientForm.value.medicalPhoto = [];
  }
  if (Array.isArray(files)) {
    files.forEach((res) => {
      patientForm.value.medicalPhoto.push(`${FILE_BASE_URL}/${res.filePath}`);
    });
  }

  ElMessage.success("文件上传成功");
  console.log("文件上传路径为:", patientForm.value.medicalPhoto);
};

const uploadToLafnew = async (options) => {
  const { file, onSuccess, onError } = options;

  const uploadToOwnServer = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    const userId = nanoid();
    formData.append("userId", userId);

    try {
      const response = await PatientUploadFiles(formData);
      console.log("服务器响应:", response);
      onSuccess(response);
    } catch (error) {
      onError(error);
      ElMessage.error("文件上传失败");
    }
  };

  try {
    await uploadToOwnServer(file);
  } catch (error) {
    onError(error);
  }
};

const submitForm = async () => {
  try {
    await validateForm();
    console.log("提交表单", patientForm.value, referralForm.value);

    const formData = new FormData();
    formData.append("patientid", patientForm.value.patientid);
    formData.append("patientname", patientForm.value.patientname);
    formData.append("patientphone", patientForm.value.patientphone);
    formData.append(
      "medicalPhoto",
      JSON.stringify(patientForm.value.medicalPhoto)
    );
    formData.append("diagnosis", JSON.stringify(patientForm.value.diagnosis));

    formData.append(
      "referralhospital",
      JSON.stringify(referralForm.value.referralhospital)
    );
    formData.append(
      "referraldepartment",
      referralForm.value.referraldepartment
    );
    formData.append(
      "referraldoctorName",
      referralForm.value.referraldoctorName
    );

    const result = await PatientReferalPatient(formData);
    ElMessage.success("提交成功");
    resetForm();
    activeCard.value = "submitRecord";

    console.log(result);
  } catch (error) {
    ElMessage.error("资料未填写完整,提交失败");
  }
};

const resetForm = () => {
  patientForm.value = {
    patientname: "",
    patientid: "",
    patientphone: "",
    diagnosis: [],
    medicalPhoto: [],
  };
  referralForm.value = {
    referralhospital: "",
    referraldepartment: "",
    referraldoctorName: "",
  };
};

const goBack = () => {
  router.go(-1);
};
</script>


<style scoped>
.section {
  width: 100%;
  padding: 0 24rpx;
  box-sizing: border-box;
  &-slot {
    padding: 4px;
  }
}
</style>
